import React, { useState } from "react";
import Header from "../../../commons/header/header";
import Footer from "../../../commons/footer/footer";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Carousel styles
// import "../../naac.css"; // Ensure you have a CSS file for styling
import image3 from "../../../../assests/images/background-learner.jpg";

const policy1 = () => {
  window.open(
    `${process.env.PUBLIC_URL}/pdf/EnergyCoservationPolicy.pdf`,
    "_blank"
  );
};

const policy2 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/FeedbackPolicy.pdf`, "_blank");
};

const policy3 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/GreenCampuspolicy.pdf`, "_blank");
};

const policy4 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/HRPolicy.pdf`, "_blank");
};

const policy5 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/ITPolicy.pdf`, "_blank");
};

const policy6 = () => {
  window.open(
    `${process.env.PUBLIC_URL}/pdf/WaterconservationPolicy.pdf`,
    "_blank"
  );
};

const policy7 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/DisabilityPolicy.pdf`, "_blank");
};

const docket1 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket1.pdf`, "_blank");
};
const docket2 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket2.pdf`, "_blank");
};
const docket3 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket3.pdf`, "_blank");
};
const docket4 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket4.pdf`, "_blank");
};
const docket5 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket5.pdf`, "_blank");
};
const docket6 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket6.pdf`, "_blank");
};
const docket7 = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/docket7.pdf`, "_blank");
};

const handleQML = () => {
  window.open(`${process.env.PUBLIC_URL}/pdf/QLM_Metrics.pdf`, "_blank");
};

const QLM = () => {
  const [activeTab, setActiveTab] = useState("tab0");

  const renderContent = () => {
    switch (activeTab) {
      case "tab0":
        return (
          <div>
            <h5>
              <span className="span-color-heading">POLICIES</span>
            </h5>

            <hr />
            <table className="criteria-table">
              <thead></thead>
              <tbody>
                <tr>
                  <th>
                    <strong>S. No.</strong>
                  </th>
                  <th>
                    <strong>Description</strong>
                  </th>
                  <th>
                    <strong>Link</strong>
                  </th>
                </tr>

                {/* Row 1 */}
                <tr>
                  <td>1</td>
                  <td>
                    <span>Energy Coservation Policys</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy1}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>

                {/* Row 2 */}
                <tr>
                  <td>2</td>
                  <td>
                    <span>Feed back Policy</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy2}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>
                    <span>Green Campus policy</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy3}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>

                {/* New Row 3 */}
                <tr>
                  <td>4</td>
                  <td>
                    <span>HR Policy</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy4}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>

                {/* Row 4 */}
                <tr>
                  <td>5</td>
                  <td>
                    <span>IT Policy</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy5}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>
                    <span>Water conservation Policy</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy6}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>
                    <span>Disability Policy</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={policy7}>
                      {" "}
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr />
          </div>
        );
      case "tab1":
        return (
          <div>
            <h5>Dockets </h5>
            <hr />

            <table className="criteria-table">
              <thead></thead>
              <tbody>
                <tr>
                  <th>
                    <strong>S.No.</strong>
                  </th>
                  <th>
                    <strong>Description</strong>
                  </th>
                  <th>
                    <strong>Link</strong>
                  </th>
                </tr>

                {/* Row 1 */}
                <tr>
                  <td>1</td>
                  <td>
                    <span>Criteria 1</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket1}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>

                {/* Row 2 */}
                <tr>
                  <td>2</td>
                  <td>
                    <span>Criteria 2</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket2}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>

                {/* Row 3 */}
                <tr>
                  <td>3.</td>
                  <td>
                    <span>Criteria 3</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket3}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>

                {/* Row 4 */}
                <tr>
                  <td>4.</td>
                  <td>
                    <span>Criteria 4</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket4}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>

                <tr>
                  <td>5.</td>
                  <td>
                    <span>Criteria 5</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket5}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>

                <tr>
                  <td>6.</td>
                  <td>
                    <span>Criteria 6</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket6}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>7.</td>
                  <td>
                    <span>Criteria 7</span>
                  </td>
                  <td>
                    <button className="view-button" onClick={docket7}>
                      {" "}
                      VIEW
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      case "tab2":
        return (
          <div>
            <h5>
              Qualitative Metrics Documents –{" "}
              <button className="span-color-heading" onClick={handleQML}>
                View
              </button>
            </h5>
          </div>
        );

      default:
        return <p>Content for Tab 0</p>;
    }
  };

  return (
    <>
      <Header />
      <div className="image-section">
        <img src={image3} alt="Gallery" className="department-image" />
        <div className="overlay-text">QLM</div>
      </div>
      <div className="naac-container">
        <div className="tabs">
          <button
            className={`tab-button ${activeTab === "tab0" ? "active" : ""}`}
            onClick={() => setActiveTab("tab0")}
          >
            POLICIES
          </button>
          <button
            className={`tab-button ${activeTab === "tab1" ? "active" : ""}`}
            onClick={() => setActiveTab("tab1")}
          >
            DOCKETS
          </button>
          <button
            className={`tab-button ${activeTab === "tab2" ? "active" : ""}`}
            onClick={() => setActiveTab("tab2")}
          >
            QLM
          </button>
        </div>
        <div className="content-naac">{renderContent()}</div>
      </div>
      <Footer />
    </>
  );
};

export default QLM;
